import { useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { STORAGE_KEYS } from "@/lib/storage";
import { toast } from "sonner";

/**
 * Handles the return from Emergent Google Auth flow.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const processed = useRef(false);

  const run = useCallback(async (session_id) => {
    try {
      const { data } = await api.post("/auth/emergent-session", { session_id });
      // Backend sets both `session_token` and `access_token` httpOnly cookies.
      localStorage.setItem(STORAGE_KEYS.user, JSON.stringify(data.user));
      window.history.replaceState(null, "", window.location.pathname);
      window.location.href = "/app";
    } catch {
      toast.error("Accesso Google fallito");
      nav("/login", { replace: true });
    }
  }, [nav]);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { nav("/login", { replace: true }); return; }
    run(decodeURIComponent(match[1]));
  }, [nav, run]);

  return (
    <div className="min-h-screen flex items-center justify-center text-stone-500 text-sm">
      Accesso in corso…
    </div>
  );
}
